import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import React from "react";

export default function Cart({ isCartOpen, setIsCartOpen }) {
  return (
    <AnimatePresence>
      {isCartOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setIsCartOpen(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-end z-[50] backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            className="bg-white  rounded-3xl shadow-2xl w-[400px] h-[95vh] mt-4 relative overflow-hidden"
            initial={{ x: "100%", opacity: 0 }}
            animate={{ x: "-10px", opacity: 1 }}
            exit={{ x: "100%", opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-full h-56 relative ">
                <X onClick={() => setIsCartOpen(false) } className="absolute top-3 right-3 text-gray-800 cursor-pointer hover:bg-gray-300 rounded-full p-1 w-8 h-8 " />
                    <div className="w-full px-5 flex items-center h-16 bg-barbados" >
                        <h1 className="text-white text-2xl" >Carrito</h1>
                    </div>      
            </div>
            <div className="absolute bottom-96 left-24 ">
                        <p className="text-lg text-barbados" >Tu carrito esta vacio...</p>
            </div>

            <div className="absolute bottom-5 left-6 ">
                        <p className="text-lg text-barbados border border-barbados  p-1 w- px-20 rounded-full cursor-pointer hover:text-white hover:bg-barbados transition-all " >Continuar comprando</p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}